import { getImageProps } from 'next/image';
import styles from './BackgroundImage.module.css';
import { getBackgroundImage } from 'frontend/utils/helpers';
import classnames from 'classnames';
interface Props {
  src: string;
  children?: React.ReactNode;
  className?: string;
  overlayOption?: 'left-bottom' | 'bottom' | 'bottom-dark';
  heightOption?: '380px' | '520px' | '880px';
}
const BackgroundImage = ({
  src,
  children,
  className,
  overlayOption = 'left-bottom',
  heightOption = '380px'
}: Props) => {
  const {
    props: {
      srcSet
    }
  } = getImageProps({
    alt: '',
    width: '1162',
    height: '409',
    src
  });
  const backgroundImage = getBackgroundImage(srcSet);
  return <div data-testid="background-image" className={classnames(styles.topImageWrapper, className, {
    [`${styles.topImageWrapper520}`]: heightOption === '520px',
    [`${styles.topImageWrapper880}`]: heightOption === '880px'
  })} data-sentry-component="BackgroundImage" data-sentry-source-file="BackgroundImage.tsx">
      <div className={styles.topImage} style={{
      backgroundImage
    }}>
        {children}
      </div>
      <div data-testid="background-image-overlay" className={classnames(styles.topImageOverlay, {
      [`${styles.bottomOverlay}`]: overlayOption === 'bottom',
      [`${styles.bottomOverlayDark}`]: overlayOption === 'bottom-dark'
    })} />
    </div>;
};
export default BackgroundImage;